import { UserRoles } from '../interfaces';

export function hasAllowedRole(userRoles: UserRoles[], allowedRoles: UserRoles[]): boolean {
    return userRoles.some((role) => allowedRoles.includes(role));
}
